import * as React from 'react';
import AntInput, { InputProps as AntInputProps } from 'antd/lib/input';

import { classes } from '../../lib/strings';

import './Input.less';
import Styles from './Input.module.less';

export type InputProps = Omit<AntInputProps, 'bordered'>;

const InputBase = (
    { className, size, ...props }: InputProps,
    ref?: React.Ref<AntInput>
) => {
    return (
        <AntInput
            ref={ref}
            size={size}
            prefixCls={Styles.input}
            className={classes(
                Styles.container,
                className,
                !props.disabled && 'clickable-element'
            )}
            {...props}
        />
    );
};

export const Input = React.forwardRef(InputBase);
